import http from '@/communication/AuthConnection'
import FormatListItem from '../list-all-items/FormatListItem'

export default async ({ state, commit }, { eventId }) => {
  try {
    const { data } = await http.post(`/v1/item-pricing/add-column`, {
      eventId
    })

    const listItems = FormatListItem(data.eventItems)
    commit('SET_LIST_ITEMS', {
      listItems
    })

    commit('SET_DYNAMIC_COLUMNS', data.dynamicColumns)
    commit('GROUP_FILTERS')
    return data.eventItems
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/add-column/index.js